export enum Pattern {
  NONE,
  LINE,
  STRIPED,
  DOTTED,
  DIAGONAL
}
